module.exports = __webpack_public_path__ + "svg/cc.8777692.svg";